<template>
  <a-layout class="main-layout">
    <s-header></s-header>
    <s-router-layout></s-router-layout>
    <s-footer></s-footer>
  </a-layout>
</template>
<script>
import RouterLayout from "./RouterLayout";
import Header from "./Header";
import Footer from "./Footer";
export default {
  components: {
    "s-router-layout": RouterLayout,
    "s-header": Header,
    "s-footer": Footer
  },
  data() {
    return {
      menu: [
        { title: "我的账户", name: "dashboard" },
        { title: "我的关键人", name: "keyperson" },
        { title: "我的采购商", name: "buyer" },
        { title: "查询记录", name: "findlog" },
        { title: "个人信息", name: "profile" }
      ]
    };
  },
  mounted() {
    // 验证登录
    // this.$http.post("/accountInfo");
  }
};
</script>

<style lang="scss" scoped>
@import "./style/mixin.scss";
.ant-layout-sider {
  border-right: 1px solid #e9eef2;
  border-left: 1px solid #e9eef2;
}
.contenter {
  .content {
    width: 1200px;
    margin: 0 auto;
  }
}
.ant-layout-header {
  padding: 0;
  height: 75px;
  background-color: #e9eef2;
  .logo {
    display: inline-block;
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    background: url("~@/assets/img/logo.png") no-repeat;
  }
}
.avatar {
  width: 200px;
  height: 200px;
  text-align: center;
  img {
    margin: auto;
    padding-top: 50px;
    display: inherit;
  }
}

.icon {
  width: 24px;
  height: 24px;
  display: inline-block;
}

.icon-dashboard {
  margin-left: 30px;
  &.router-link-active::before {
    @include menu-icon;
    background-position: -22px 0 !important;
  }
  &::before {
    @include menu-icon;
    background-position: 0 0;
  }
}

.icon-keyperson {
  margin-left: 30px;
  &.router-link-active::before {
    @include menu-icon;
    background-position: -22px -22px !important;
  }
  &::before {
    @include menu-icon;
    background-position: 0 -22px;
  }
}
.icon-buyer {
  margin-left: 30px;
  &.router-link-active::before {
    @include menu-icon;
    background-position: -22px -42px !important;
  }
  &::before {
    @include menu-icon;
    background-position: 0 -42px;
  }
}
.icon-findlog {
  margin-left: 30px;
  &.router-link-active::before {
    @include menu-icon;
    background-position: -22px -62px !important;
  }
  &::before {
    @include menu-icon;
    background-position: 0 -62px;
  }
}
.icon-profile {
  margin-left: 30px;
  &.router-link-active::before {
    @include menu-icon;
    background-position: -22px -82px !important;
  }
  &::before {
    @include menu-icon;
    background-position: 0 -82px;
  }
}
.ant-menu-item {
  line-height: 60px;
  height: 60px;
  border-bottom: 1px solid #e9eef2;
  margin: 0 !important;
  color: #6bafe1;
}
.ant-menu-item:first-child {
  border-top: 1px solid #e9eef2;
}
.ant-menu-item-selected,
.ant-menu-item-selected > a,
.ant-menu-item-selected > a:hover {
  background-color: #f4faf9 !important;
  color: #05926d !important;
}
</style>
